import { LoginWithRedirectAdapterInteractor } from '../../auth/domain/interactors/login-with-redirect.interactor';
import { GoogleIdentityService } from '../../common/google/google-identity.service';

export class LoginWithRedirectGoogleAdapterInteractor
  implements LoginWithRedirectAdapterInteractor
{
  constructor(
    private readonly clientId: string,
    private readonly googleIdentityService: GoogleIdentityService,
    private readonly redirectUri: string,
    private readonly scopes: string[],
  ) {}

  public async execute(
    state: string,
    _pkceChallenge: string,
    _authTypeChanged: boolean,
  ): Promise<void> {
    await this.googleIdentityService.load();

    const codeClientFlow = google.accounts.oauth2.initCodeClient({
      client_id: this.clientId,
      scope: this.scopes.join(' '),
      ux_mode: 'redirect',
      redirect_uri: this.redirectUri,
      state,
    });

    codeClientFlow.requestCode();
  }
}
